define('drops/businessProcess/businessProcess',['jquery',
		'underscore',
		'lq/drop'
], function (
		$,
		_,
		Drop) {
        'use strict';

        var defaults = {
            data: {
                type: 'BusinessProcess'
            }
        };

        function BusinessProcess(model) {
            Drop.call(this, $('<div class="licquid-drops-pool" style="overflow:hidden;" >&nbsp;</div>'), defaults, model);
            Drop.rootDrop = this;

            this.applyPosition();

            this.$element.css({
                zIndex: '5999'
            });
        };

        Drop.extend(BusinessProcess, Drop);

        BusinessProcess.typeName = 'BusinessProcess';
    
        return BusinessProcess;
    });

